<template>
  <div class="chat hide-mobile">
    <div class="chat__circle">
      <Icon icon="chat" color="detailed" @click.native="toggleChat()" title="Chat öffnen"/>
    </div>
    <div ref="phone" class="phone">
      <div class="phone__text">
        <p>Behördennummer 115</p>
        <p>Auch telefonisch bestens beraten!</p>
      </div>
      <div class="phone__icon">
        <a href="tel:115">
          <Icon icon="phone" title="115 Anrufen"/>
        </a>
      </div>
    </div>
    <div ref="chat" class="chat__tooltip">
      <div class="chat__tooltip__top">
        <div class="chat__tooltip__top--intro">
          <p class="color-bluegrey">Guten Tag,</p>
          <h3 class="color-white">Wie kann ich Ihnen helfen?</h3>
          <Icon class="close" icon="close" color="white" @click.native="toggleChat()" title="Chat schließen"/>
          <div class="contact-card">
            <div class="contact-card__image">
              <img src="../../assets/images/logo-white.svg" alt="">
            </div>
            <div class="contact-card__name">
              <h6>{{ contactPerson }}</h6>
              <p>Beamtin in der inneren Verwaltung der Stadt Augsburg</p>
            </div>
          </div>
        </div>
      </div>
      <div class="chat__tooltip__middle">
        <transition-group name="msg-enter">
          <div :class="{'message own' : message.ownMsg, 'message' : !message.ownMsg}" v-for="message in messages" :key="message.msg">
            <div v-if="!message.ownMsg" class="message__img"><img src="../../assets/images/logo-white.svg" alt=""></div>
            <span class="message__text">{{ message.msg }}</span>
          </div>
        </transition-group>
      </div>
      <div class="chat__tooltip__bottom">
        <form @submit.prevent="sendMsg">
          <input type="text" name="message" id="message" v-model="message" placeholder="Ihre Nachricht an uns..." autocomplete="off">
          <input type="submit" name="send" id="send" value="SENDEN" @click.prevent="sendMsg">
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '../../components/Icon/Icon';

export default {
  name: 'Chat',
  components: {
    Icon,
  },
  data() {
    return {
      first: true,
      message: '',
      messages: [],
    };
  },
  props: {
    contactPerson: {
      type: String,
      default: 'Auxbot'
    },
  },
  computed: {
  },
  methods: {
    toggleChat() {
      this.$refs.chat.classList.toggle('open');
      if(this.first) {
        setTimeout(() => {this.messages.push({msg: 'Benötigen Sie Hilfe?', ownMsg: false})}, 2000);
        this.first = false;
      }
      this.$refs.phone.classList.toggle('open-phone');
    },
    sendMsg(message) {
      this.messages.push({msg: this.message, ownMsg: true});
      this.message = '';
      if(this.messages[this.messages.length-1].msg.toLowerCase().includes('nein')) {
        setTimeout(() => {this.messages.push({msg: 'Okay 🤓 Meld dich wenn du mich brauchst', ownMsg: false})}, 3000);
      } else {
        setTimeout(() => {this.messages.push({msg: 'Sorry, Ich bin doch nur ein Prototyp 😢', ownMsg: false})}, 3000);
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./Chat.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Chat/Chat.vue